import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Paper,
  CircularProgress,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { postRequest } from '../../utils/ApiRequests';
import './candidates.scss';

const MobileNumberInput = ({ onSendOTP, onBack, handleSnackBar }) => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [loading, setLoading] = useState(false);

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only digits
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handleSendOTP = async () => {
    if (!mobileNumber || mobileNumber.length !== 10) {
      handleSnackBar(true, 'Please enter a valid 10-digit mobile number', 'error');
      return;
    }

    // Validate first digit should be greater than 5
    const firstDigit = parseInt(mobileNumber[0]);
    if (firstDigit <= 5) {
      handleSnackBar(true, 'Please enter a valid mobile number', 'error');
      return;
    }

    // Check if all digits are the same
    const allSameDigits = mobileNumber.split('').every(digit => digit === mobileNumber[0]);
    if (allSameDigits) {
      handleSnackBar(true, 'Please enter a valid mobile number', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await postRequest('admin/otp/send', {
        mobile: mobileNumber,
      });

      if (response.data.status === 'Success' || response.data.success) {
        handleSnackBar(true, 'OTP sent successfully', 'success');
        onSendOTP(mobileNumber);
      } else {
        handleSnackBar(true, response.data.message || 'Failed to send OTP', 'error');
      }
    } catch (err) {
      handleSnackBar(
        true,
        err?.response?.data?.message || 'Failed to send OTP',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && mobileNumber.length === 10) {
      handleSendOTP();
    }
  };

  return (
    <Container maxWidth="sm" style={{ marginTop: '50px' }}>
      <Paper elevation={3} style={{ padding: '40px', borderRadius: '12px' }}>
        <Box textAlign="center" mb={4}>
          <Box
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            bgcolor="primary.main"
            color="white"
            borderRadius="50%"
            width={60}
            height={60}
            mb={2}
          >
            <PhoneIcon fontSize="large" />
          </Box>
          <Typography variant="h5" gutterBottom fontWeight="600">
            Create New Candidate
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Enter the candidate's mobile number to get started
          </Typography>
        </Box>

        <Box mb={3}>
          <TextField
            fullWidth
            label="Mobile Number"
            variant="outlined"
            value={mobileNumber}
            onChange={handleMobileChange}
            onKeyPress={handleKeyPress}
            placeholder="Enter 10-digit mobile number"
            inputProps={{
              maxLength: 10,
            }}
            autoFocus
            helperText="We'll send a verification code to this number"
          />
        </Box>

        <Box mb={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSendOTP}
            disabled={loading || mobileNumber.length !== 10}
            style={{ height: '50px' }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Send OTP'}
          </Button>
        </Box>

        <Box textAlign="center">
          <Button
            variant="text"
            color="secondary"
            onClick={onBack}
            disabled={loading}
          >
            Back to Candidates List
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default MobileNumberInput;
